<template>
  <div class="page">
    <slot />
    <div class="overlay" v-if="demo"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      overlayClass: ""
    };
  },

  computed: {
    demo() {
      return this.$store.getters.demo;
    }
  },

  beforeMount() {
    this.overlayClass = this.generateUuid();
  },

  mounted() {
    const style = document.createElement("style");
    style.setAttribute("type", "text/css");
    style.appendChild(
      document.createTextNode(`
      .${this.overlayClass} {
      }`)
    );
    document.head.appendChild(style);
  },

  methods: {
    generateUuid(chars) {
      const arr = new Uint8Array((chars || 8) / 2);
      window.crypto.getRandomValues(arr);
      return Array.from(arr, dec => dec.toString(16).padStart(2, "0")).join("");
    }
  }
};
</script>

<style scoped lang="scss">
.page {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

div > .overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1 !important;
  background: transparent url("../assets/sample_bro.png") center center repeat;
}
</style>
